import { render, staticRenderFns } from "./dicManage.vue?vue&type=template&id=327ece57&scoped=true&"
import script from "./dicManage.vue?vue&type=script&lang=js&"
export * from "./dicManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327ece57",
  null
  
)

export default component.exports